import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IconDirective } from '@coreui/icons-angular';
import { I18nService, TranslatePipe } from 'i18n';

/**
 * The support hub: "Tell us what you need — we take you to the right place."
 * Three ways, no departments (customer principle 5 and answer R2-9):
 *
 *   I have a question   → Ask Dr. Future (Zammad group `health_concierge`)
 *   I need support      → general support: login, account, billing (group `Support`)
 *   My requests         → everything the member has asked, both groups, one list
 *
 * A member never has to know which team is behind a way — the route data of the
 * target page carries the group.
 */
@Component({
  selector: 'gh-support-hub-page',
  standalone: true,
  imports: [RouterLink, IconDirective, TranslatePipe],
  templateUrl: './support-hub-page.component.html',
  styleUrls: ['./support-hub-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SupportHubPageComponent {
  private i18n = inject(I18nService);
  get lang(): string { return this.i18n.getLanguage(); }
}
